export enum RestorePunchesChoiceEnum {
	RETURN = 'return',
	KEEP = 'keep',
}

export enum DeleteType {
	ALL = 'all',
	EVENT = 'event',
	ADDON = 'addon',
}
